export const environment = {
    production: false,
    apiURL: 'https://apigatewaydemo.cunamutual.com/cmfg/demo-int/',
    apiManagerURL: 'https://demo-apimanager.trustage.com/',
    clientID: '29f455c3-c46b-4b3c-9888-184bf6aa5aea',
    apiManagerKey: 'ef823a68cba14614bbe9aec5b6b8aea2',
    recaptchaSiteKeyV2: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    recaptchaSiteKeyV3: '6Ld1TeorAAAAAB1w1zcBhAOYvp8ModLAsNSnCypk'
};